/** Tooltip copy for the drawer's EDR restrictions. */
export const ACRONIS_EDR_ACTIVE_TITLE = 'Acronis EDR active';

export const ACRONIS_EDR_CLOUD_BACKUPS_MESSAGE =
	'This server is running Acronis EDR. We recommend Acronis Cloud storage for full EDR protection.';

export const ACRONIS_EDR_STORAGE_LOCATION_MESSAGE =
	"This server is running Acronis EDR. You'll need to select Acronis Cloud as your location.";
